var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionExternalLink18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75c-.413 0-.766-.147-1.06-.44a1.446 1.446 0 01-.44-1.06V3.75c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44H9v1.5H3.75v10.5h10.5V9h1.5v5.25c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H3.75zm3.525-3.975l-1.05-1.05L13.2 3.75h-2.7v-1.5h5.25V7.5h-1.5V4.8l-6.975 6.975z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionExternalLink18);
export default __webpack_public_path__ + "88ff7b36a7a7cddb29ccf80f32eebc21.svg";
export { ForwardRef as ReactComponent };